export default __webpack_public_path__ + "static/media/ethereum-logo.a0eeb777.svg";